import apiClient from "@/api/client";
import { saveBlobResponse } from "@/utils/download";
import type { Requisition } from "../types";

export const requisitionsApi = {
  list: (params?: Record<string, string>) =>
    apiClient.get<{ data: Requisition[] }>("/requisitions/", { params }).then((r) => r.data.data),

  // „Pobierz zapotrzebowania (.xlsx)" z listy — te same parametry co /requisitions/feed/
  // (filtry, ?q=, ?ordering=, exclude_status), ale serwer zwraca WSZYSTKIE pasujące
  // wiersze, nie doczytaną porcję.
  downloadListXlsx: async (params: Record<string, string>) => {
    const resp = await apiClient.get("/requisitions/export-xlsx/", { params, responseType: "blob" });
    saveBlobResponse(resp, "Zapotrzebowania.xlsx");
  },

  get: (id: string) =>
    apiClient.get<{ data: Requisition }>(`/requisitions/${id}/`).then((r) => r.data.data),

  create: (payload: unknown) =>
    apiClient.post<{ data: Requisition }>("/requisitions/", payload).then((r) => r.data.data),

  update: (id: string, payload: unknown) =>
    apiClient.patch<{ data: Requisition }>(`/requisitions/${id}/`, payload).then((r) => r.data.data),

  submit: (id: string) =>
    apiClient.post<{ data: Requisition }>(`/requisitions/${id}/submit/`).then((r) => r.data.data),

  // `extra` to pola spoza overrides — dziś udostępnienie plików projektu ZE
  // (share_project_files / share_all_nonconfidential / share_folder_slugs).
  approve: (id: string, overrides?: unknown, extra?: Record<string, string>) =>
    apiClient
      .post(`/requisitions/${id}/approve/`, { overrides: overrides ?? {}, ...(extra ?? {}) })
      .then((r) => r.data),

  reject: (id: string, comment?: string) =>
    apiClient.post(`/requisitions/${id}/reject/`, { comment: comment ?? "" }).then((r) => r.data),

  reopen: (id: string) =>
    apiClient.post<{ data: Requisition }>(`/requisitions/${id}/reopen/`).then((r) => r.data.data),

  delete: (id: string) =>
    apiClient.delete(`/requisitions/${id}/`).then((r) => r.data),

  deleteAttachment: (id: string, fileId: string) =>
    apiClient.delete(`/requisitions/${id}/attachments/${fileId}/`),

  getAuditLogs: (id: string) =>
    apiClient.get<{ data: AuditLog[] }>(`/requisitions/${id}/audit-logs/`).then((r) => r.data.data),

  addAuditLog: (id: string, description: string, mentionIds: string[] = []) =>
    apiClient
      .post(`/requisitions/${id}/audit-logs/`, { description, mention_ids: mentionIds })
      .then((r) => r.data),
};

export interface AuditLog {
  id: string;
  user: string;
  user_name: string;
  description: string;
  // Oznaczeni w notatce — front podświetla ich po nazwisku w treści wpisu.
  mentions: { id: string; full_name: string }[];
  created_at: string;
}
